var _path, _path2, _rect, _rect2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockDetailed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 16.5C26 23.4036 20.4036 29 13.5 29C6.59644 29 1 23.4036 1 16.5C1 9.59644 6.59644 4 13.5 4C20.4036 4 26 9.59644 26 16.5Z",
    stroke: "#A3A3A3",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.5V17H19",
    stroke: "#A3A3A3",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#A3A3A3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1387,
    y: 2.19336,
    width: 6.20398,
    height: 2.88712,
    rx: 1,
    transform: "rotate(44.6947 23.1387 2.19336)",
    fill: "#A3A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 1V4",
    stroke: "#A3A3A3",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockDetailed);
export default __webpack_public_path__ + "static/media/clock-detailed.b2f3d94dd8d26066c909827a7638237a.svg";
export { ForwardRef as ReactComponent };